import React from 'react'

const Paragraph = ({ paragraphKeywordArray, paragraph, type }) => {
     return (
        <p className='lead py-1'>
           { paragraph && 

                paragraph.split(/[ ,]+/).map(word => {
                    if (paragraphKeywordArray.includes(word))
                        return (
                        <span key={word} className={type}>
                            {`${word} `}
                        </span>
                    )
                    return (
                            `${word} ` 
                    )
                })
            }
        </p>
     )
    
    
     
    
   
}

export default Paragraph
